import { MANIFESTO, IMAGES } from "@/data/content";
import { Reveal } from "@/components/Reveal";

export const About = () => {
  return (
    <section
      id="about"
      className="relative bg-surface py-24 sm:py-32 scroll-mt-20 overflow-hidden"
      data-testid="about-section"
    >
      {/* leaf texture accent */}
      <div className="absolute right-0 top-0 h-full w-1/3 opacity-20 hidden lg:block">
        <img
          src={IMAGES.leafTexture}
          alt=""
          aria-hidden="true"
          className="h-full w-full object-cover"
        />
        <div className="absolute inset-0 bg-gradient-to-l from-transparent to-surface" />
      </div>

      <div className="relative mx-auto max-w-[1500px] px-5 sm:px-8 lg:px-12">
        <Reveal className="max-w-3xl mb-16">
          <div className="flex items-center gap-3 mb-6">
            <span className="text-xs uppercase tracking-[0.3em] text-brand font-semibold">
              Our Story
            </span>
            <span className="h-px w-16 bg-white/15" />
          </div>
          <h2 className="font-display font-bold uppercase tracking-tighter text-[#f2f4f0] text-4xl sm:text-6xl lg:text-7xl leading-[0.92]">
            From the Delta,
            <br />
            <span className="text-brand">to your grounds.</span>
          </h2>
        </Reveal>

        <div className="grid lg:grid-cols-2 gap-x-16 gap-y-4">
          {MANIFESTO.map((chapter, i) => (
            <Reveal
              key={chapter.num}
              delay={i * 0.08}
              className="relative border-t border-white/10 py-10 group"
              data-testid={`manifesto-${chapter.num}`}
            >
              <span
                aria-hidden="true"
                className="absolute -top-2 right-0 font-display font-extrabold text-7xl sm:text-8xl text-outline opacity-40 select-none pointer-events-none group-hover:opacity-70 transition-opacity duration-500"
              >
                {chapter.num}
              </span>
              <span className="text-brand font-display font-bold text-sm tracking-widest">
                {chapter.num}
              </span>
              <h3 className="mt-3 font-display font-bold uppercase tracking-tight text-2xl text-[#f2f4f0]">
                {chapter.title}
              </h3>
              <p className="mt-3 max-w-md text-[15px] text-[#8d948f] leading-relaxed">
                {chapter.body}
              </p>
            </Reveal>
          ))}
        </div>

        {/* Specialty callout */}
        <Reveal className="mt-20 border border-brand/40 bg-obsidian p-8 sm:p-12">
          <div className="grid md:grid-cols-2 gap-8">
            <div>
              <p className="text-xs uppercase tracking-[0.3em] text-brand font-semibold">
                Our Specialty
              </p>
              <p className="mt-4 font-display font-bold uppercase tracking-tight text-2xl sm:text-3xl text-[#f2f4f0] leading-tight">
                Landscape Construction & Maintenance for Commercial Clients
              </p>
            </div>
            <div className="md:border-l md:border-white/10 md:pl-8">
              <p className="text-xs uppercase tracking-[0.3em] text-[#8d948f] font-semibold">
                Clientele Includes
              </p>
              <ul className="mt-4 space-y-2 text-[#c7ccc4]">
                {["Schools", "Colleges", "New Buildings", "Infrastructure Projects"].map(
                  (c) => (
                    <li key={c} className="flex items-center gap-3">
                      <span className="h-1.5 w-1.5 bg-brand" />
                      {c}
                    </li>
                  )
                )}
              </ul>
            </div>
          </div>
        </Reveal>
      </div>
    </section>
  );
};
